import type { FeatureManifest } from '../registry.js';
import { mayHaveVisitors } from './signal.js';

/**
 * SO-09 customer steal (P2, friendly rivalry): serve one customer at a friend's shop (from the
 * shop tour), and on the victim's side a map card listing the visitors taken from you, each with
 * a 24-hour "take back". The card comes back once per session while a visitor can still be taken
 * back and the player has not let them stay, so it is the victim's way back to the list at any
 * level (no unlock: an invite link makes friends below the Friends level). Customer art loads per
 * view (customers_<city>).
 */
export default {
  id: 'steal',
  flag: 'customerSteal',
  online: true,
  provides: ['stealConfirm', 'stealVisitors'],
  // after last week's results (20), before offers (30): new visitors can still be taken back
  mapOrder: 26,
  mapDue: (a) => a.services.sync.status !== 'offline' && !a.session.checked.has('steal') && mayHaveVisitors(a),
  load: () => import('./index.js'),
} satisfies FeatureManifest;
